import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { queryClient } from "./index";

const STALE_TIME = Infinity;

export const useProjectTemplateDependenciesCount = (id, config) => {
  return useQuery({
    ...config,
    queryKey: ["dependencies-count", id],
    queryFn: () => {
      return fetch({
        url: `${Angie.api_url}/project-templates/${id}/dependencies-count`,
      });
    },
  });
};

export const invalidateTemplateDependenciesCount = (templateId) => {
  queryClient.invalidateQueries(["dependencies-count", String(templateId)]);
};

export const useHasActiveProjectsTemplates = (config) => {
  return useQuery({
    ...config,
    staleTime: STALE_TIME,
    queryKey: "has-active-templates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/project-templates/has-templates`,
        signal,
      }),
  });
};

export const invalidateHasActiveProjectsTemplate = () => {
  queryClient.invalidateQueries(["has-active-templates"]);
};
